import PropTypes from 'prop-types';
import {Todo} from 'front-onceforall-core';
import {DOCUMENT_STATE} from 'front-onceforall-core/dist/utils/documents';
import Message from './message';
import Action from './action';

const icon = {
  [DOCUMENT_STATE.AWAITING_SIGNATURE]: 'rounded-sign',
  [DOCUMENT_STATE.EXPIRED]: 'clock',
  [DOCUMENT_STATE.MISSING]: 'rounded-plus',
  [DOCUMENT_STATE.REJECTED]: 'rounded-cross'
};

const DocumentView = ({document, onActionClick}) => (
  <Todo
    icon={icon[document.state]}
    message={<Message document={document}/>}
  >
    <Action
      document={document}
      onClick={onActionClick}
    />
  </Todo>
);

DocumentView.propTypes = {
  document: PropTypes.object.isRequired,
  onActionClick: PropTypes.func.isRequired
};

export default DocumentView;
